import React, { useContext, useState } from 'react';
import './Register.css';
import '../../component/layouts/Style.css';
import { Link , useNavigate } from 'react-router-dom';


import Helmet from '../../component/Helmet/Helmet';

import { Container, Row, Col } from 'reactstrap';

import Sidebar from '../../component/layouts/Sidebar';
import RightSide from '../../component/layouts/rightSide';
import MobileTopBar from '../../component/layouts/MobileTopBar';
import { AppContext } from '../../context/AppContext';


const Register = () => {


    const {token, setToken} = useContext(AppContext);

    const [preview, setPreview] = useState(null);




    const [formData, setFormData] = useState({
            name: '',
            email:'',
            password:'',
            phone:'',
            bio:'',
            username:''
    })

    const [errors, setErrors] = useState({}); 


const handleChanges = (e) => {
  const { name, value, files } = e.target;

  if (name === "file") {
    const file = files[0];
    setFormData({ ...formData, file });

    if (file) {
      setPreview(URL.createObjectURL(file));
    } else {
      setPreview(null);
    }
  } else {
    setFormData({ ...formData, [name]: value });
  }
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({}); 

    console.log(111);
    

    console.log('====================================');
    console.log(formData);
    console.log('====================================');

    console.log(1);
    

    try {
      const response = await fetch('https://dashboard.tiktaka.com/api/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'

        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      console.log(data);
      

      if (response.ok) {
            alert("✅ تم التسجيل بنجاح!");
            console.log(data);

            localStorage.setItem('token', data.token); 
            localStorage.setItem('name', formData.name); 

            setToken(data.token);

            // navigate('/home'); // حول المستخدم على الصفحة الرئيسية


        } else if (response.status === 422) {
            setErrors(data.errors);
        } else {
            console.log(data.message);
            
            // alert("❌ فيه مشكلة: " + (data.message || "حاول تاني"));
        }

    } catch (error) {
      console.error(error);
      alert('⚠ حصل خطأ في الاتصال بالسيرفر');
      alert(error);
    }
  };


  return (
  <Helmet title='Register'>
    <div className="Register">
    
        <Sidebar/>

        <div className='midSide'>
        <div className='middleSideHome'>

        <MobileTopBar/>
        
        {/* Start Main Section */}

            <div className='mainSection'>
            <section>
                    <Container>
                        <Row>
                            <Col lg='6' md='6' sm='12' className='loginBox'>
                            <form onSubmit={handleSubmit} className='material-form'>
                            <h1>Register</h1>

                            <div className='input-field'>
                                <input type='text' placeholder='name' name='name'  value={formData.name}
                                        onChange={handleChanges} ></input>
                                <label>Name</label>
                                <span className="bar"></span>
                                {errors.name && (
                                        <div style={{ color: "red", fontSize: "12px" }}>
                                        {errors.name[0]}
                                        </div>
                                )}
                            </div>
                            <div className='input-field'>
                                <input type='text'
                                        placeholder='enter your username'
                                        name='username' 
                                        value={formData.username}
                                        onChange={(e) => handleChanges(e)} 
                                >                                   
                                </input>
                                <label>UserName</label>
                                <span className="bar"></span>
                                {errors.username && (
                                        <div style={{ color: "red", fontSize: "12px" }}>
                                        {errors.username[0]}
                                        </div>
                                )}
                            </div>

                            <div className='input-field'>
                                <input type='text' placeholder='email' name='email'  value={formData.email}
                                        onChange={handleChanges} ></input>
                                <label>Email</label>
                                <span className="bar"></span>
                                {errors.email && (
                                        <div style={{ color: "red", fontSize: "12px" }}>
                                        {errors.email[0]}
                                        </div>
                                )}
                            </div>

                            <div className='input-field'>
                                <input type='number' placeholder='phone' name='phone'  value={formData.phone}
                                        onChange={handleChanges} ></input>
                                <label>Phone</label>
                                <span className="bar"></span>
                                {errors.phone && (
                                        <div style={{ color: "red", fontSize: "12px" }}>
                                        {errors.phone[0]}
                                        </div>
                                )}
                            </div>



                            <div className='input-field'>

                                <textarea name="bio" id="bio" cols="30" rows="10"  placeholder='enter your bio' value={formData.bio} onChange={(e) => handleChanges(e)}>

                                </textarea>


                                <label>Bio</label>
                                <span className="bar"></span>
                            {errors.bio && (
                                    <div style={{ color: "red", fontSize: "12px" }}>
                                    {errors.bio[0]}
                                    </div>
                                )}

                            </div>

                            <div className='input-field'>
                                <input type='file' placeholder='select your photo' name='file' onChange={(e) => handleChanges(e)}  >
                                </input>
                                <label>Photo</label>
                                <span className="bar"></span>   
                                
                            </div>

                            {preview && (
                                <div style={{ marginTop: "10px" }}>
                                    <img
                                    src={preview}
                                    alt="Preview"
                                    style={{ maxWidth: "200px", borderRadius: "10px" }}
                                    />
                                </div>
                                )}

                            <div className='input-field'>
                                <input type='text' placeholder='password' name='password'  value={formData.password}
                                        onChange={handleChanges} ></input>
                                <label>Password</label>
                                <span className="bar"></span>
                                {errors.password && (
                                        <div style={{ color: "red", fontSize: "12px" }}>
                                        {errors.password[0]}
                                        </div>
                                )}
                            </div>


                            <button type='submit'>Submit</button>
                            <div className='rememberForget'>
                                <Link to='/login'>already have an account</Link> / 
                                <Link to='/forgetpass'> Forget Password</Link>
                            </div>
                            </form>
                            </Col>
                        </Row>
                    </Container>
            </section>
            </div>
        {/* End Main Section  */}
        </div>
        </div>

        <RightSide />

    </div>
  </Helmet>
  );
};

export default Register;